"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Auth;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _Auth = _interopRequireDefault(require("composer-lib/data/model/Auth"));

function Auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Auth.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.SET_AUTH:
      return _Auth.default.fromJS(action.data);

    default:
      return state;
  }
}

module.exports = exports.default;